module.exports = __webpack_public_path__ + "static/media/camera-icon.aa33821a.svg";